import { render, staticRenderFns } from "./PartPagination.vue?vue&type=template&id=16b864ed&scoped=true&"
import script from "./PartPagination.vue?vue&type=script&lang=js&"
export * from "./PartPagination.vue?vue&type=script&lang=js&"
import style0 from "./PartPagination.vue?vue&type=style&index=0&id=16b864ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b864ed",
  null
  
)

export default component.exports